import React from "react";

import Button from "../../../button/Button";

export default function BusinessCell(props) {
    const name = props.business.get("Name");

    const style = {
        cellContainer: {
            display: "flex",
            flexDirection: "row",
            position: "relative",
            alignItems: "center",
            marginTop: 8,
            paddingTop: 8,
            paddingBottom: 8,
            borderBottom: "1px solid var(--soft-grey)"
        },
        nameLabel: {
            fontWeight: "bold",
            lineHeight: "1.8em",
            maxHeight: "1.8em",
            textOverflow: "elipsis",
            wordWrap: "break-word",
            overflow: "hidden"
        },
        imageView: {
            position: "relative",
            height: 56,
            width: 56,
            marginRight: 12
        },
        image: {
            height: 56,
            width: 56,
            borderRadius: 28,
            overflow: "hidden",
            objectFit: "cover"
        },
        medalImage: {
            position: "absolute",
            height: 20,
            width: 20,
            bottom: -3,
            right: -3
        },
        dataView: {
            display: "flex",
            flex: 1,
            flexDirection: "column"
        },
        pointsLabel: {
            color: "var(--coral)",
            marginLeft: 8,
            marginRight: 3,
            fontWeight: "bold"
        },
        newLabel: {
            color: "#fff",
            marginLeft: 8,
            fontWeight: "bold",
            backgroundColor: "var(--coral)",
            fontSize: 10,
            padding: 4,
            height: 22,
            alignItems: "center",
            borderRadius: 4
        },
        button: {
            marginLeft: 8
        }
    };

    return (
        <section style={style.cellContainer}>
            <div style={style.imageView}>
            <img style={style.image} src={props.business.has("Logo") ? props.business.get("Logo").url() : require("../../../../assets/business.svg").default} alt="logo-business"/>
            </div>
            <div style={style.dataView}>
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center"
                    }}
                >
                    <label style={style.nameLabel}>{name}</label>
                </div>
            </div>
            <Button
                style={style.button}
                buttonText={props.buttonText ? props.buttonText : "Ver"}
                onClick={props.onClick}
            />
        </section>
    );
}
